/// <reference types="vite/client" />
import {
    HeadContent, Outlet, Scripts, createRootRouteWithContext, ClientOnly,
} from '@tanstack/react-router'

// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'

import { HTMLProps } from 'react'

// import type { QueryClient } from '@tanstack/react-query'
import { DefaultCatchBoundary } from '~/components/DefaultCatchBoundary'
import { NotFound } from '~/components/NotFound'
import { seo } from '~/utils/seo'
import { Fonts, InconsolataVariable } from '~/components/addons/Fonts'
import { Icons } from '~/components/addons/Icons'
import { Header } from '~/components/shared/Header'
import { Footer } from '~/components/shared/Footer'

import appCss from '~/styles/app.css?url'

import cn from 'classnames'
import Tracking, { TrackingFallback } from '~/components/addons/Tracking'

export const Route = createRootRouteWithContext<{
    // queryClient: QueryClient
}>()({
    head: () => (
        {
            meta: [{
                charSet: 'utf-8',
            }, {
                name: 'viewport',
                content: 'width=device-width, initial-scale=1',
            }, ...seo({
                title: 'Privacy Watch',
                description: `Which coin dominates the privacy market?`,
                image: '/meta.jpg',
            }), {
                name: 'og:video',
                content: '/meta.mp4',
            }, {
                name: 'og:video:type',
                content: 'video/mp4',
            }, {
                name: 'og:video:width',
                content: '1200',
            }, {
                name: 'og:video:height',
                content: '630',
            }, {
                name: 'twitter:video',
                content: '/meta.mp4',
            }, {
                name: 'twitter:video:type',
                content: 'video/mp4',
            }, {
                name: 'twitter:video:width',
                content: '1200',
            }, {
                name: 'twitter:video:height',
                content: '630',
            }],
            links: [{
                rel: 'stylesheet',
                href: appCss,
            }, {
                rel: 'icon',
                sizes: '32x32',
                href: '/favicon.ico',
            }, {
                rel: 'icon',
                type: 'image/svg+xml',
                href: '/favicon.svg',
            }, {
                rel: 'apple-touch-icon',
                type: 'image/png',
                sizes: '180x180',
                href: '/favicon.png',
            }, {
                rel: 'manifest',
                href: '/site.webmanifest',
                color: '#fffff',
            }, {
                rel: 'preload',
                as: 'font',
                type: 'font/woff2',
                href: InconsolataVariable,
                crossOrigin: 'anonymous',
            }, ...(
                ['11', '22', '33', '44', '55']
                    .map(frame => (
                        [{
                            rel: 'preload',
                            as: 'image',
                            type: 'image/webp',
                            href: `/images/frames/eye-blink/${frame}.webp`,
                        }, {
                            rel: 'preload',
                            as: 'image',
                            type: 'image/webp',
                            href: `/images/frames/eye-blink/${frame}@2x.webp`,
                        }]
                    ))
            ).flat()],
        }
    ),
    errorComponent: (props) =>
    {
        return (
            <DefaultCatchBoundary {...props} />
        )
    },
    notFoundComponent: () => <NotFound />,
    shellComponent: RootShell,
    component: RootComponent,
    ssr: true,
})

type RootShellProps = HTMLProps<HTMLHtmlElement>

function RootShell ({ children }: RootShellProps)
{
    return (
        <html lang={'en'} className={cn('h-full')}>
        <head>
            <HeadContent />

            <Fonts />

            <ClientOnly fallback={<TrackingFallback />}>
                <Tracking />
            </ClientOnly>
        </head>
        <body className={cn('px-4 xl:px-10 h-full')}>
        <Icons />

        {/*<Header className={cn('max-w-8xl mx-auto', 'mb-3 md:mb-4', 'h-15')} />*/}

        <Header className={cn('max-w-8xl mx-auto', 'mb-3 md:mb-4', 'h-5')} aria-hidden={true} />

        <div className={cn('min-h-full mb-6', 'md:mb-9')}>
            {children}
        </div>

        <Footer className={cn('max-w-8xl mx-auto')} />

        <TanStackRouterDevtools position="bottom-right" />

        {/*<ReactQueryDevtools buttonPosition="bottom-left" />*/}

        <Scripts />
        </body>
        </html>
    )
}

function RootComponent ()
{
    return (
        <Outlet />
    )
}
